/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import StandardTemplate from "./StandardTemplate";

class ExpandableSiblingTemplate extends StandardTemplate {

    getFieldClass() {
        return "col-sm-7";
    }
}

export default ExpandableSiblingTemplate;
